import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
const META_PIXEL_ID = '1378915894061182';
export function App() {
  useEffect(() => {
    // Standard Meta Pixel base code
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    const n: any = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    w.fbq = n;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
    // Noscript fallback pixel
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <main className="min-h-screen w-full bg-cream text-charcoal overflow-x-hidden selection:bg-sage/30" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <TargetAudience data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <Modules data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Comparison data-id="element-8" />
      <Pricing data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
      <PurchaseToast data-id="element-13" />
    </main>;
}